import React, { FC, SyntheticEvent } from 'react';
import { useDispatch } from 'react-redux';
import { Icon } from '@cld/icon';
import { useAnalytics } from '../../../../hooks/useAnalytics';
import { removeMedia } from '../../../../actions';
import { MediaType } from '../../../../types';
import { ImgContainer, RemoveImg, OpenInNewContainer, RemoveImgContainer, OtherFileIcon } from './InsertedMedia.styled';

const removeExtension = (path: string) => path.substr(0, path.lastIndexOf('.'));
const replaceExtension = (path: string, newExtension: string) => `${removeExtension(path)}.${newExtension}`;

export interface MediaItemProps {
  item: MediaType;
  index: number;
}

export const MediaItem: FC<MediaItemProps> = ({ item, index }) => {
  const analytics = useAnalytics();

  const dispatch = useDispatch();
  const handleDelete = (event: SyntheticEvent) => {
    analytics('remove', 'remove asset from the inserted media pane');
    event.preventDefault();
    dispatch(
      removeMedia({
        index,
      })
    );
  };

  const imgSrc = item.type === 'video'
    ? replaceExtension(item.url, 'png')
    : item.type === 'image'
    ? item.url
    : null ;

  return (
    <ImgContainer href={item.url} target="_blank" onClick={() => analytics('navigate', 'open asset in a new tab')}>
      {imgSrc ? <img src={imgSrc} alt={item.url} data-test="media-img" /> : <OtherFileIcon />}
      <RemoveImgContainer onClick={handleDelete} data-test="delete-media">
        <RemoveImg />
      </RemoveImgContainer>
      <OpenInNewContainer>
        <Icon name="openInNew" size="sm" />
      </OpenInNewContainer>
    </ImgContainer>
  );
};
